export default __webpack_public_path__ + "a39d2c6496e3a1ce6bb3020852a9b1cf.svg";